// extracted by mini-css-extract-plugin
export default {"plan-card":"PlanCard_plan-card__TXzdQ","plan-card-top":"PlanCard_plan-card-top__XOxzn","price-title":"PlanCard_price-title__0Lkjo"};